import '../styles/PageNotFound.css';

const PageNotFound = () => {
    return (
        <div className="page-not-found">
            <h1>Error 404, Page Eaten by Snoofs.</h1>
            <img className="snoof" src="https://i.imgur.com/HGZSoxS.png" alt="snoof" />
        </div>
    );
};

export default PageNotFound;